import React from "react";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../_helpers";

export default function SettingsNav() {
    return (
        <div className="">
            <div className="text-muted mb-4 font-weight-bolder font-size-lg">Company Settings</div>

            <div className="navi navi-spacer-x-0 p-0">
                <a href="/user/profile" className="navi-item">
                    <div className="navi-link">
                        <div className="symbol symbol-40 bg-light mr-3">
                            <div className="symbol-label">
                                <span className="svg-icon svg-icon-md svg-icon-primary">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/General/Settings-2.svg")}/>
                                </span>
                            </div>
                        </div>
                        <div className="navi-text">
                            <div className="font-weight-bold">General Settings</div>
                            <div className="text-muted">Details, logo, agent and more</div>
                        </div>
                    </div>
                </a>

                <a href="/user/profile" className="navi-item">
                    <div className="navi-link">
                        <div className="symbol symbol-40 bg-light mr-3">
                            <div className="symbol-label">
                                <span className="svg-icon svg-icon-md svg-icon-success">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Group.svg")}/>
                                </span>
                            </div>
                        </div>
                        <div className="navi-text">
                            <div className="font-weight-bold">Company users</div>
                            <div className="text-muted">Registered company users</div>
                        </div>
                    </div>
                </a>

                <a href="/user/profile" className="navi-item">
                    <div className="navi-link">
                        <div className="symbol symbol-40 bg-light mr-3">
                            <div className="symbol-label">
                                <span className="svg-icon svg-icon-md svg-icon-danger">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Shield-user.svg")}/>
                                </span>
                            </div>
                        </div>
                        <div className="navi-text">
                            <div className="font-weight-bold">Administrator Accounts</div>
                            <div className="text-muted">OptimumDesk administrator accounts</div>
                        </div>
                    </div>
                </a>

                <a href="/user/profile" className="navi-item">
                    <div className="navi-link">
                        <div className="symbol symbol-40 bg-light mr-3">
                            <div className="symbol-label">
                                <span className="svg-icon svg-icon-md svg-icon-warning">
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Media/Equalizer.svg")}/>
                                </span>
                            </div>
                        </div>
                        <div className="navi-text">
                            <div className="font-weight-bold">Reports</div>
                            <div className="text-muted">
                                Reports settings, schedule and more
                            </div>
                        </div>
                    </div>
                </a>
            </div>

        </div>
    );
}
